import {
  Payment,
  Product,
  Properties,
  subData,
  VehicleData,
} from 'pages/Settings/pages/Add-subscription/types/Add-subscription.types';
import cms from './cms';

const VEHICLE_DATA_KEY = 'vehicleData';

const orderVehicles = (vehiculos: VehicleData): VehicleData => {
  const ordenar = (obj: Record<string, string[]>): Record<string, string[]> =>
    Object.keys(obj)
      .map((marca) => marca.trim())
      .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
      .reduce<Record<string, string[]>>((acc, marca) => {
        acc[marca] = obj[marca]
          .map((modelo) => modelo.trim())
          .sort((a, b) =>
            a.localeCompare(b, undefined, { sensitivity: 'base' })
          );
        return acc;
      }, {});

  return {
    autos: ordenar(vehiculos.autos),
    motos: ordenar(vehiculos.motos),
  };
};

const saveVehicleDataToLocalStorage = (data: VehicleData) => {
  localStorage.setItem(VEHICLE_DATA_KEY, JSON.stringify(data));
};

const getVehicleDataFromLocalStorage = (): VehicleData | null => {
  const data = localStorage.getItem(VEHICLE_DATA_KEY);
  return data ? JSON.parse(data) : null;
};

export const removeVehicleDataFromLocalStorage = () => {
  localStorage.removeItem(VEHICLE_DATA_KEY);
};

export async function getProductsByCompany(
  companyId: number
): Promise<Product[]> {
  try {
    const response = await cms.get(`/v2/products/company/${companyId}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to get products by companyId 🚨');
  }
}

export async function getDataByKey(key: string): Promise<VehicleData> {
  try {
    const cachedData = getVehicleDataFromLocalStorage();
    if (cachedData) return cachedData;

    const response = await cms.get(`/v2/data-store/${key}`);
    const vehiclesOrdered = orderVehicles(response.data);
    saveVehicleDataToLocalStorage(vehiclesOrdered);
    return vehiclesOrdered;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to get data of autos and motos 🚨');
  }
}

interface CreateSubProps {
  properties: Properties;
  sub: subData;
  payment: Payment;
  authId: string;
}

export async function createSub({
  properties,
  sub,
  authId,
  payment,
}: CreateSubProps) {
  try {
    const data = { properties, sub, payment };
    const response = await cms.post(
      `/v2/add-subscription-buy-plan/${authId}`,
      data
    );

    return response.data;
  } catch (error) {
    console.error('Error createSub 🚨', error);
    throw error;
  }
}
